module.exports = __webpack_public_path__ + "img/resAndTank.590bea80.svg";